import PublishContent from "./Content";
import PublishSummary from "./Summary";

export const PublishStep = {
  Content: PublishContent,
  Summary: PublishSummary
}